/* RESPONSIBLE TEAM: team-actions */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    samlAccount: {
      serialize: 'records',
      deserialize: 'records',
    },
    scimSettings: {
      serialize: 'records',
      deserialize: 'records',
    },
  },
});
